<template>
    <v-dialog v-bind:value="dialog" max-width="500px" persistent>
        <v-card>
            <v-card-title>
                <span class="headline">
                    {{ "" }}
                </span>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-form ref="form" v-model="formValid" lazy-validation>
                                <v-row>
                                    <v-col cols="12">
                                        <v-select
                                            :items="distances"
                                            label="Distancia"
                                            v-model="selectedDistance"
                                            item-text="nombre"
                                            item-value="id"
                                            required
                                        >
                                            <template v-slot:item="{ item }">
                                                {{ item.nombre }}
                                            </template>
                                            <template v-slot:selection="{ item }">
                                                {{ item.nombre }}
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-select
                                            :items="sizes"
                                            label="Talla Camiseta"
                                            v-model="selectedSize"
                                            item-value="id"
                                            required
                                        >
                                            <template v-slot:item="{ item }">
                                                {{ item.talla.nombre }}
                                            </template>
                                            <template v-slot:selection="{ item }">
                                                {{ item.talla.nombre }}
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" v-if="isRaceCustomizable">
                                        <v-text-field v-model="customization" label="Personaliza tu camiseta"
                                            :rules="PersonalizacionRules" required></v-text-field>
                                    </v-col>
                                    <v-col> </v-col>
                                </v-row>
                            </v-form>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" text @click="onClose">
                    Cancelar
                </v-btn>
                <v-btn color="#5a897d" outlined @click="save">
                    Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Vue from "vue";
import CarreraService from '@/api/CarreraService';
import RegistroCarreraService from "@/api/carrera/detalle/RegistroCarreraService";

export default Vue.extend({

    props: [
        "dialog",
        "loadedInscription",
    ],
    data() {
        return {
            inscription: this.loadedInscription,
            distances: [],
            sizes: [],
            couponCode: null,
            customization: null,
            selectedDistance: null,
            selectedSize: null,
            formValid: true,
            PersonalizacionRules: [
                (v) => v.length <= 10 || "La logintud no debe ser mayor a 10",
                (v) =>
                !v || /^[a-z0-9 .#@_-]+$/i.test(v) || "Carácter no permitido"
            ],
        };
    },
    computed: {
        isRaceCustomizable() {
            return this.inscription?.carrera?.estadoPersonalizacion == '1';
        }
    },
    methods: {
        alert(msg) {
            alert(msg);
        },
        onClose() {
            this.inscription = null;
            this.$emit('on-close');
        },
        loadSelectsOptions() {
            if (!this.inscription) return;

            CarreraService.getProximaCarrera(this.inscription.carrera.id)
                .then((race) => {
                    this.sizes = race.tallasCamisetas;
                    this.distances = race.distancias;
                })
                .catch(() => {
                    console.error('Some error ocurred retrieving race data.');
                });
        },
        save() {
            if (!this.$refs.form.validate()) {
                return;
            }

            RegistroCarreraService.actualizarDatosRegistro(this.inscription.id, {
                customization: this.customization,
                distanciaId: this.selectedDistance,
                tallaCamisetaId: this.selectedSize,
            })
                .then(() => {
                    this.$swal({
                        toast: true,
                        position: "center",
                        showConfirmButton: false,
                        timer: 2000,
                        icon: "success",
                        title: "Mensaje del sistema",
                        text: "Datos guardados con exito"
                    });

                    this.$emit('after-save');
                    this.onClose();
                })
                .catch(() => {
                    this.$swal({
                        toast: true,
                        position: "center",
                        showConfirmButton: false,
                        timer: 2000,
                        icon: "error",
                        title: "Mensaje del sistema",
                        text: "No se pudo guardar"
                    });
                })
        }
    },
    watch: {
        loadedInscription(newValue) {
            this.inscription = newValue;
            this.couponCode = null;

            if (newValue) {
                this.loadSelectsOptions();
                this.selectedSize = this.inscription?.tallaCamiseta?.id;
                this.selectedDistance = this.inscription?.distancia?.id;
            }
        }
    },
});
</script>
